import { type FC, type HTMLAttributes, type ReactNode } from 'react'

import './index.scss'

export interface LabelTextProps extends HTMLAttributes<HTMLLabelElement> {
  children: ReactNode
  className?: string
}

export const LabelText: FC<LabelTextProps> = ({ children, className = '', ...rest }) => (
  <label className={`label-text ${className}`} {...rest}>
    {children}
  </label>
)
